module.exports = {"id":"190716","name":"Préjuce Nakoulma","rating":"74","photo":"./data/images/photos/2/190716.png","club":{"name":"FC Nantes","logo":"./data/images/clubs/FCNantes.png"},"positions":["BU","MG","MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PrejuceNakoulma0.json
// module id = 3486
// module chunks = 0